import axios from "axios";
import { HOST_URL } from '@/config/api';

export const baseRequset = axios.create({
  baseURL: HOST_URL
})
